/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './message-modal.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../app/components/modals/message-modal/message-modal.component';
import * as i4 from 'ngx-bootstrap/modal/modal-options.class';
import * as i5 from '@angular/router';
import * as i6 from '../../../../../app/shared/_services/hotel-management.service';
import * as i7 from '../../../../../app/shared/_services/marketing.service';
const styles_MessageModalComponent:any[] = [i0.styles];
export const RenderType_MessageModalComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_MessageModalComponent,data:{}});
function View_MessageModalComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'div',[['class',
      'modal-header text-center']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,
      0,(null as any),(null as any),1,'h3',[['class','modal-title'],['id','exampleModalLabel']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(3,(null as any),['',''])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵeld(5,0,(null as any),(null as any),1,'p',[['xngIf','srcObject.status == \'Active\' || srcObject.status == null']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(6,(null as any),['',''])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.srcObject.title;
        _ck(_v,3,0,currVal_0);
        const currVal_1:any = _co.srcObject.message;
        _ck(_v,6,0,currVal_1);
      });
}
function View_MessageModalComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',[['class',
      'modal-footer'],['style','text-align:center']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),
      i1.ɵeld(2,0,(null as any),(null as any),1,'button',[['class','btn btn-default'],
          ['data-dismiss','modal'],['id','deleteModal'],['type','button']],(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.confirmClose()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(3,(null as any),['',''])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.srcObject.action2;
    _ck(_v,3,0,currVal_0);
  });
}
export function View_MessageModalComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_MessageModalComponent_1)),i1.ɵdid(1,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n'])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_MessageModalComponent_2)),i1.ɵdid(4,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n']))],(_ck,_v) => {
    var _co:i3.MessageModalComponent = _v.component;
    const currVal_0:any = (_co.srcObject.mode == 'custom');
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = (_co.srcObject.mode == 'custom');
    _ck(_v,4,0,currVal_1);
  },(null as any));
}
export function View_MessageModalComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'message-modal-modal',
      ([] as any[]),(null as any),(null as any),(null as any),View_MessageModalComponent_0,
      RenderType_MessageModalComponent)),i1.ɵdid(1,114688,(null as any),0,i3.MessageModalComponent,
      [i4.BsModalRef,i5.Router,i6.HotelManagementService,i7.MarketingService],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const MessageModalComponentNgFactory:i1.ComponentFactory<i3.MessageModalComponent> = i1.ɵccf('message-modal-modal',
    i3.MessageModalComponent,View_MessageModalComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvbW9kYWxzL21lc3NhZ2UtbW9kYWwvbWVzc2FnZS1tb2RhbC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vYXBwL3NyYy9hcHAvY29tcG9uZW50cy9tb2RhbHMvbWVzc2FnZS1tb2RhbC9tZXNzYWdlLW1vZGFsLmNvbXBvbmVudC50cyIsIm5nOi8vL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvbW9kYWxzL21lc3NhZ2UtbW9kYWwvbWVzc2FnZS1tb2RhbC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvbW9kYWxzL21lc3NhZ2UtbW9kYWwvbWVzc2FnZS1tb2RhbC5jb21wb25lbnQudHMuTWVzc2FnZU1vZGFsQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cIm1vZGFsLWhlYWRlciB0ZXh0LWNlbnRlclwiICpuZ0lmPVwic3JjT2JqZWN0Lm1vZGUgPT0gJ2N1c3RvbSdcIj5cbiAgPGgzIGNsYXNzPVwibW9kYWwtdGl0bGVcIiBpZD1cImV4YW1wbGVNb2RhbExhYmVsXCI+e3tzcmNPYmplY3QudGl0bGV9fTwvaDM+XG4gIDxwIHhuZ0lmPVwic3JjT2JqZWN0LnN0YXR1cyA9PSAnQWN0aXZlJyB8fCBzcmNPYmplY3Quc3RhdHVzID09IG51bGxcIj57e3NyY09iamVjdC5tZXNzYWdlfX08L3A+XG48L2Rpdj5cbjxkaXYgY2xhc3M9XCJtb2RhbC1mb290ZXJcIiBzdHlsZT1cInRleHQtYWxpZ246Y2VudGVyXCIgKm5nSWY9XCJzcmNPYmplY3QubW9kZSA9PSAnY3VzdG9tJ1wiPlxuICA8YnV0dG9uIHR5cGU9XCJidXR0b25cIiBjbGFzcz1cImJ0biBidG4tZGVmYXVsdFwiICBpZD1cImRlbGV0ZU1vZGFsXCIgZGF0YS1kaXNtaXNzPVwibW9kYWxcIiAoY2xpY2spPVwiY29uZmlybUNsb3NlKClcIj57e3NyY09iamVjdC5hY3Rpb24yfX08L2J1dHRvbj5cbjwvZGl2PlxuIiwiPG1lc3NhZ2UtbW9kYWwtbW9kYWw+PC9tZXNzYWdlLW1vZGFsLW1vZGFsPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBQSxnQkFBeUUsNENBQ3ZFO01BQUE7TUFBQSx3RUFBK0M7YUFBQSwyQkFBd0I7TUFDdkU7VUFBQTtNQUFvRSwwQ0FBeUI7OztRQUQ5QztRQUFBO1FBQ3FCO1FBQUE7Ozs7b0JBRXRFO01BQUE7TUFBQSw4QkFBdUYsNENBQ3JGO2FBQUE7VUFBQTtVQUFBO1lBQUE7WUFBQTtZQUFxRjtjQUFBO2NBQUE7WUFBQTtZQUFyRjtVQUFBLGdDQUE4RztNQUE4Qjs7SUFBOUI7SUFBQTs7OztvQkFMaEg7TUFBQSxzQ0FBQTtvQkFBQSxtQ0FHTTtNQUFBLFNBQ047TUFBQSxzQ0FBQTtvQkFBQSxtQ0FFTTtNQUFBOztJQU5nQztJQUF0QyxXQUFzQyxTQUF0QztJQUlvRDtJQUFwRCxXQUFvRCxTQUFwRDs7OztvQkNKQTtNQUFBO3NDQUFBLFVBQUE7TUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/modals/message-modal/message-modal.component.ngfactory.ts